import { render, staticRenderFns } from "./shipper.vue?vue&type=template&id=657a4266&"
import script from "./shipper.vue?vue&type=script&lang=js&"
export * from "./shipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('657a4266')) {
      api.createRecord('657a4266', component.options)
    } else {
      api.reload('657a4266', component.options)
    }
    module.hot.accept("./shipper.vue?vue&type=template&id=657a4266&", function () {
      api.rerender('657a4266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/basic/shipper.vue"
export default component.exports